import { handleCrmSyncMessage } from "./crm-events.js";
import { handleWhatsappSyncMessage } from "./whatsapp-events.js";

export function handleSyncMessage(msg) {
  if (!msg || typeof msg !== "object") return;
  if (msg.op === "ack") return;
  if (msg.op === "pong") return;
  if (handleCrmSyncMessage(msg)) return;
  handleWhatsappSyncMessage(msg);
}
